import data from "../../.sourceflow/jobs.json";
import CollectionHelper from "@/helpers/CollectionHelper";

const LOCATION_CATEGORY_ID = "ddb8172b-abe7-4b03-adf9-d20228ebae70";
const CONSULTANT_CATEGORY_ID = "a0f229b0-8ee5-4ddc-a797-ddf77ee5dd49";

class JobsCollectionHelper extends CollectionHelper {
  fetch({
    limit = null,
    featured = null,
    sector = null,
    speciality = null,
    group = null,
    branch = null,
    location = null,
    consultant = null,
    exclude = null,
    filter = null,
  } = {}) {
    let items = this.collection.getItems();

    if (filter) {
      items = items.filter(filter);
    }

    if (sector) {
      if (Array.isArray(sector)) {
        items = items.filter((i) => sector.some((s) => JSON.stringify(i.categories).includes(s)));
      } else {
        items = items.filter((i) => JSON.stringify(i.categories).includes(sector));
      }
    }

    if (speciality) {
      if (Array.isArray(speciality)) {
        items = items.filter((i) => speciality.some((s) => JSON.stringify(i.categories).includes(s)));
      } else {
        items = items.filter((i) => JSON.stringify(i.categories).includes(speciality));
      }
    }

    if (group) {
      if (Array.isArray(group)) {
        items = items.filter((i) => group.some((g) => JSON.stringify(i.categories).includes(g)));
      } else {
        items = items.filter((i) => JSON.stringify(i.categories).includes(group));
      }
    }

    if (branch) {
      if (Array.isArray(branch)) {
        items = items.filter((i) => branch.some((b) => JSON.stringify(i.categories).includes(b)));
      } else {
        items = items.filter((i) => JSON.stringify(i.categories).includes(branch));
      }
    }

    if (location) {
      const locations = Array.isArray(location) ? location : [location];

      items = items.filter((i) => {
        const category = i.categories?.find((c) => c.id === LOCATION_CATEGORY_ID);

        return category?.values?.some((v) => locations.includes(v.id) || locations.includes(v.name));
      });
    }

    if (consultant) {
      const consultants = Array.isArray(consultant) ? consultant : [consultant];

      items = items.filter((i) => {
        const category = i.categories?.find((c) => c.id === CONSULTANT_CATEGORY_ID);

        return category?.values?.some((v) => consultants.includes(v.id));
      });
    }

    if (featured) {
      items = items.filter((i) => i.featured === featured);
    }

    if (exclude) {
      items = items.filter((i) => !exclude.includes(i.id));
    }

    if (limit) {
      items = items.slice(0, limit);
    }

    return items;
  }
  getCategoryValues(search, { categories }) {
    const category = categories.find((i) => i.id === search || i.name === search);

    if (!category) {
      return [];
    }

    return category.values;
  }

  getCategoryValueIds(search, { categories }) {
    return this.getCategoryValues(search, { categories }).map((i) => i.id);
  }
}

export const jobs_helper = new JobsCollectionHelper(data.jobs);
